import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore/lite";
import { getFunctions } from "firebase/functions";
import { getPerformance } from "firebase/performance";
import { getStorage } from "firebase/storage";

// Get config from session storage if in development, otherwise use env vars
const getFirebaseConfig = () => {
  if (import.meta.env.VITE_APP_MODE === "development") {
    const sessionConfig = localStorage.getItem('firebaseConfig');
    if (sessionConfig) {
      return JSON.parse(sessionConfig);
    }
  }

  return {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
    projectId: import.meta.env.VITE_FIREBASE_PROJECTID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGEBUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  };
};

const firebaseConfig = getFirebaseConfig();

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
const storage = getStorage(firebaseApp);
const cloudFunctions = getFunctions(firebaseApp, "europe-west1");

export default firebaseApp;
export { auth, db, storage, cloudFunctions, firebaseConfig };
